import PeluangSPK from './PeluangSPK';

export default PeluangSPK;
